import { observable, action, makeObservable } from 'mobx';

export class LoaderModel {
    @observable
    public isOpen: boolean;

    @observable
    public title: string;

    @observable
    public requestCount: number;

    constructor(
        isOpen: boolean = false,
        requestCount: number = 0,
        title: string = ''
    ) {
        this.isOpen = isOpen;
        this.requestCount = requestCount;
        this.title = title;
        makeObservable(this);
    }

    @action
    show(title: string = '') {
        this.title = title || this.title;
        this.isOpen = true;
        this.requestCount++;
    }

    @action
    hide() {
        this.requestCount = Math.max(--this.requestCount, 0);
        if (this.requestCount === 0) {
            this.title = '';
            this.isOpen = false;
        }
    }
}

export default LoaderModel;
